// Helpers
import { convertToIsoDateTime } from "@common/components/helpers/datetime";

const prepareAgeVerificationData = (data, formData, siteGuid) => {
  return {
    ...formData.record,
    ...data,
    ageVerificationDate: convertToIsoDateTime(data.date, data.time),
    idType: data.hasId ? data.idType : null,
    description: data.hasId && data.idType.detailsRequired ? data.otherId : "",
    gender: data.hasId ? data.gender : null,
    dateOfBirth: data.hasId
      ? convertToIsoDateTime(data.dateOfBirth, "12:00")
      : null,
    isUnder18: data.hasId && data.under18 && data.under18Confirm,
    hasGambled: !data.hasId && data.hasGambled,
    hasHadStakeReturned:
      !data.hasId && data.hasGambled && data.hasHadStakeReturned,
    hasBeenRefusedEntry: !data.hasId && data.hasBeenRefusedEntry,
    site: { guid: siteGuid },
  };
};

export default prepareAgeVerificationData;
